import React, {Component} from 'react';
import toastr from "toastr";
import * as authService from '../../../services/authService';
import {getJwt} from '../../../services/authService';

import http from "../../../services/httpService";
import axios from "axios";

import AddContactModal from '../../modals/AddContactModal';

import {MultiSelect} from "@blueprintjs/select";
import {Menu, MenuItem, Tag, Spinner, Callout, Icon, Intent, Overlay, Classes} from '@blueprintjs/core';

import SearchBox from '../../common/SearchBox';

// import ReactGA from "react-ga";
import DeleteContactsModal from '../../modals/DeleteContactsModal';
import {CSVLink} from "react-csv";
import sizeMe from 'react-sizeme';

import MUIDataTable from "mui-datatables";
import {createTheme, MuiThemeProvider} from '@material-ui/core/styles';
import ChartLoader from '../../utils/chart-loader';
import CustomToolbarSelect from './CustomToolbarSelect';
import CustomFooter from "./CustomFooter";
import countries from "../../common/countries";

import Theme from "../../../components/common/MuiTheme";

/* End of MuiDatatables data */

class Contacts extends Component {
    constructor(props) {
        super(props);
        this.intervalRef = React.createRef();
        this.state = {
            tableLoader: false,
            contacts: [],
            checkedContacts: [],
            searched_contacts: [],
            totalContacts: 0,
            totalPages: 1,
            pageSize: 25,
            currentPage: 1,
            lastPage: false,
            lastPageSize: '',
            paging: '',
            forceTableRerender: false,
            minTableWidth: 500,
            lastColumnWidth: 500,
            bulkLoader: false,
            tags: [],
            selectedTags: [],
            selectedTagsIds: [],
            addContactModalActive: false,
            editContactModalActive: false,
            contactsImportActive: false,
            deleteContactsModalActive: false,
            deleteAllContactsModalActive: false,
            addContactError: '',
            editContactError: '',
            saveContactLoader: false,
            editContactLoader: false,
            selectAllChecked: false,
            contactsAdded: '',
            contactsNotImported: '',
            arrayOfUnsuccessfulImportedContacts: [],
            deleteAllContactsLoader: false,
            selectedContact: '',
            bulkTags: [],
            loadingContactsFull: false,
            rowsSelected: [],
            allContactsChecked: true,
            createTagString: '',
            createTagLoader: false,
            tagsNames: [],
            tagsImportActive: false,
            bulkIsOpen: undefined,
            workspaceChanged: false,
            sort: 'desc',
            contactsSearchActive: false,
            searchTerm: '',
            sortData: {
                name: 'updated_at_timezone',
                direction: 'desc'
            }
        }

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };
    }



    async componentDidMount() {
        // await this.setState({ width });
        //  ReactGA.pageview(window.location.pathname + window.location.search);
        
        let contactsRowsPerPage = await localStorage.getItem("contactsRowsPerPage");
        let pageSize = await JSON.parse(contactsRowsPerPage)
        await this.setState({initialTableLoader: true, contactsImportActive: false, pageSize: pageSize || 25})
        let userId = await this.props.userId;
        let selectedSource = await this.props.selectedSource;

        if (userId && selectedSource) {
            try {
                const contactsResult = await http.get('/api/user/' + userId + '/project/' + selectedSource + '/imported_contacts/page_size/' + this.state.pageSize + '?page=' + this.state.currentPage, {headers: {authorization: getJwt()}})
                // console.log('contactsResult', contactsResult);

                await this.setState({
                    initialTableLoader: false,
                    contacts: contactsResult.data.imported_contacts,
                    searched_contacts: contactsResult.imported_contacts,
                    totalContacts: contactsResult.data.total_count,
                    totalPages: contactsResult.data.total_pages,
                })
                let totalContactsBefore = await this.state.totalContacts;

                if (this.props.location.state) {
                    let importActiveWorkspaceId = await this.props.selectedSource;
                    await this.setState({
                        contactsImportActive: true,
                        totalContactsBefore: contactsResult.data.total_count
                    })
                    let jobId = this.props.location.state.jobId;
                    // console.log('Evo ga jobId: ', jobId, this.state.contactsImportActive)
                    const interval = setInterval(async () => {
                        const jobStatus = await http.get('/api/user/' + userId + '/project/' + selectedSource + '/jobs_sqs/' + jobId, {headers: {authorization: getJwt()}})
                        // console.log('Evo ga jobStatus: ', jobStatus.data.job_sqs)
                        if (this.state.workspaceChanged) {
                            await clearInterval(interval);
                            await this.setState({
                                workspaceChanged: false,
                                contactsImportActive: false,
                                contactsAdded: '',
                                contactsNotImported: '',
                                arrayOfUnsuccessfulImportedContacts: []
                            })
                        } else if (jobStatus?.data?.job_sqs?.processing === 1) {
                            await this.setState({contactsImportActive: true})
                        } else if (jobStatus?.data?.job_sqs?.processing === 0) {

                            // console.log('importActiveWorkspaceId check: ', importActiveWorkspaceId, this.props.selectedSource)
                            if (importActiveWorkspaceId === this.props.selectedSource) {
                                let contactsResult  = {};
                                let unprocessedContactsResult = {}
                                try{
                                    contactsResult = await http.get('/api/user/' + userId + '/project/' + selectedSource + '/imported_contacts/page_size/' + this.state.pageSize + '?page=' + this.state.currentPage, {headers: {authorization: getJwt()}});
                                }catch{
                                    toastr.error('imported_contacts error')
                                }

                                try{
                                    unprocessedContactsResult = await http.post('/api/user/' + userId + '/project/' + selectedSource + '/unprocessed_contacts/' + jobId, {}, {headers: {authorization: getJwt()}});
                                }catch{
                                    toastr.error('unprocessed_contacts error')
                                }

                                // console.log('Zavrsio se import, evo rezultata: ', unprocessedContactsResult.data.total_count, unprocessedContactsResult);
                                if(jobStatus?.data?.job_sqs?.unprocessed_json_exporting_done === '1' && unprocessedContactsResult?.data?.unprocessed_contacts_csv_link){

                                    let newTotalContacts = await contactsResult.data.total_count;
                                    let totalContactsAdded = await jobStatus.data.job_sqs.count_total;
                                    // console.log('Contacts before and new total contacts: ', totalContactsBefore, newTotalContacts)
                                    // let contactsAdded = await (parseInt(newTotalContacts) - parseInt(totalContactsBefore));
                                    // let contactsNotImported = await (parseInt(jobStatus.data.job_sqs.count_total) - contactsAdded);
                                    await clearInterval(interval);

                                    let contactsAdded = await (parseInt(totalContactsAdded) - parseInt(unprocessedContactsResult.data.total_count));
                                    let contactsNotImported = await unprocessedContactsResult.data.total_count;

                                    await this.handleGetUnprocessed(unprocessedContactsResult?.data?.unprocessed_contacts_csv_link, contactsNotImported);

                                    // let parsedArray = jsonData.data && jsonData.data.length ? await JSON.parse(jsonData.data) : '';
                                    // let arrayOfUnsuccessfulImportedContacts = await data;
                                        // console.log('arrayOfUnsuccessfulImportedContacts: ', arrayOfUnsuccessfulImportedContacts, arrayOfUnsuccessfulImportedContacts.length)

                                        // console.log('contactsAdded: ', contactsAdded, ' contactsNotImported: ', contactsNotImported)
                                    await this.setState({
                                        // contactsImportActive: false,
                                        contacts: contactsResult.data.imported_contacts,
                                        totalContacts: newTotalContacts,
                                        totalPages: contactsResult.data.total_pages,
                                        contactsAdded,
                                        // arrayOfUnsuccessfulImportedContacts
                                    })
                                }

                            }
                        }
                    }, 5000);

                    this.intervalRef.current = interval;
                }

            } catch (ex) {
                await clearInterval(this.intervalRef.current);
                await this.setState({
                    workspaceChanged: false,
                    contactsImportActive: false,
                    contactsAdded: '',
                    contactsNotImported: '',
                    arrayOfUnsuccessfulImportedContacts: []
                })
                if (ex.response && ex.response.status === 404)
                    toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        }
    }

    handleGetUnprocessed = async (link, contactsNotImported) => {
        // console.log('handleGetUnprocessed')
        let randomNumber = Math.floor(Math.random() * 1001);

        const interval2 = setInterval(async () => {
            let jsonData = await axios.get(link + '?nocache=' + randomNumber);
            randomNumber = Math.floor(Math.random() * 1001);

            // console.log('jsonData: ', randomNumber, Array.isArray(jsonData.data), jsonData)
            if(Array.isArray(jsonData.data)){
                let data = await jsonData?.data?.filter(item=>item)
                // console.log('pre clear')
                await clearInterval(interval2);
                // console.log('posle clear')
                this.setState({
                    contactsImportActive: false,
                    arrayOfUnsuccessfulImportedContacts: data,
                    contactsNotImported
                })
            }
        }, 2000);

        this.intervalRef.current = interval2;
    }



    async componentDidUpdate() {
        // console.log('didUpdate: ', this.state.arrayOfUnsuccessfulImportedContacts)
        if (this.props.tags.length && !this.state.tagsNames.length) {
            let tagsNames = [];
            this.props.tags.map(tag => tagsNames.push(tag.tag))
            this.setState({tagsNames})
        }
        if (this.props.selectedSource && (this.props.selectedSource !== this.state.selectedSource)) {
            // console.log('project changed: ', this.props.selectedSource, this.state.selectedSource)

            let userId = await this.props.userId;
            let selectedSource = await this.props.selectedSource;

            if (!this.state.selectedSource) {
                await this.setState({selectedSource: this.props.selectedSource})
            } else {
                await this.setState({selectedSource: this.props.selectedSource})
                try {
                    const contactsResult = await http.get('/api/user/' + userId + '/project/' + selectedSource + '/imported_contacts/page_size/' + this.state.pageSize + '?page=' + this.state.currentPage, {headers: {authorization: getJwt()}})
                    let contacts = contactsResult.data.imported_contacts;
                    // console.log('contactsResult', contactsResult);
                    if (this.props.selectedSource && this.state.selectedSource && (this.props.selectedSource !== this.state.selectedSource)) {
                        // console.log('promenjen workspace: ', this.state.workspaceChanged, this.state.contactsImportActive, this.state.contactsAdded)
                        // Command bellow is used for clearing this.props.location.state when workspace is changed
                        this.props.history.replace(this.props.location.pathname, null);
                        await this.setState({
                            contacts,
                            searched_contacts: contacts,
                            totalContacts: contactsResult.data.total_count,
                            totalPages: contactsResult.data.total_pages,
                            tableLoader: false,
                            selectedSource: this.props.selectedSource,
                            workspaceChanged: true,
                            contactsImportActive: false,
                            contactsAdded: '',
                            contactsNotImported: '',
                            arrayOfUnsuccessfulImportedContacts: [],
                            loadingContactsFull: false
                        })
                    } else {
                        await this.setState({
                            contacts,
                            searched_contacts: contacts,
                            totalContacts: contactsResult.data.total_count,
                            totalPages: contactsResult.data.total_pages,
                            tableLoader: false,
                            selectedSource: this.props.selectedSource,
                        })
                    }

                    if (this.state.tableLoader) {
                        this.setState({tableLoader: false})
                    }

                } catch (e) {
                    //console.log('contactsResult error: ', e)
                }
            }
        }
    }

    componentWillUnmount() {
        clearInterval(this.intervalRef.current);
        this.setState({
            workspaceChanged: false,
            contactsImportActive: false,
            contactsAdded: '',
            contactsNotImported: '',
            arrayOfUnsuccessfulImportedContacts: []
        })
    }

    handlePageChange = async (number) => {
        // console.log('handlePageChange: ', number)
        let page = parseInt(number)
        let userId = await this.props.userId;
        let selectedSource = await this.props.selectedSource;

        let columnName = this.state.sortData.name;
        let direction = this.state.sortData.direction;

        if ((page !== 0) && (page !== this.state.lastPage)) {
            await this.setState({currentPage: page, tableLoader: true});
            const contactsResult = await http.post('/api/user/' + userId + '/project/' + selectedSource + '/filter_contacts/page_size/' +
                this.state.pageSize + '?page=' + number + '&order=' + direction + '&sort=' + columnName, {
                "tag_ids": this.state.selectedTagsIds,
                "term": this.state.searchTerm
            }, {headers: {authorization: getJwt()}})

            await this.setState({
                contacts: contactsResult.data.imported_contacts,
                totalPages: contactsResult.data.total_pages,
                selectedPage: page,
                currentPage: page,
                tableLoader: false
            })
        }
    };

    handleRowsPerPageChange = async (number) => {
        let pageSize = parseInt(number)
        let userId = await this.props.userId;
        let selectedSource = await this.props.selectedSource;

        let columnName = this.state.sortData.name;
        let direction = this.state.sortData.direction;

        if (pageSize !== 0) {
            await this.setState({pageSize, tableLoader: true});

            await localStorage.setItem("contactsRowsPerPage", JSON.stringify(number));
            const contactsResult = await http.post('/api/user/' + userId + '/project/' + selectedSource + '/filter_contacts/page_size/' +
                this.state.pageSize + '?page=' + 1 + '&order=' + direction + '&sort=' + columnName, {
                "tag_ids": this.state.selectedTagsIds,
                "term": this.state.searchTerm
            }, {headers: {authorization: getJwt()}})

            await this.setState({
                contacts: contactsResult.data.imported_contacts,
                totalPages: contactsResult.data.total_pages,
                selectedPage: 1,
                currentPage: 1,
                pageSize,
                tableLoader: false
            })
        }
    };

    handleSearchContacts = async (text) => {
        let userId = await this.props.userId;
        let selectedSource = await this.props.selectedSource;

        let columnName = this.state.sortData.name;
        let direction = this.state.sortData.direction;

        if (text && !this.state.contactsSearchActive) {
            this.setState({contactsSearchActive: true, searchTerm: text})
        }

        clearTimeout(this.timer);

        this.timer = setTimeout(async () => {
            try {
                const contactsResult = await http.post('/api/user/' + userId + '/project/' + selectedSource + '/filter_contacts/page_size/' +
                    this.state.pageSize + '?page=' + 1 + '&order=' + direction + '&sort=' + columnName, {
                    "tag_ids": this.state.selectedTagsIds,
                    "term": text
                }, {headers: {authorization: getJwt()}})

                await this.setState({
                    contacts: contactsResult.data.imported_contacts,
                    totalPages: contactsResult.data.total_pages,
                    totalContacts: contactsResult.data.total_count,
                    selectedPage: 1,
                    currentPage: 1,
                    tableLoader: false,
                    searchTerm: text
                })
            } catch {
                toastr.error('Error with searching contacts')
            }
        }, 1000);
    };

    handleSearchContactsClose = async () => {
        let userId = await this.props.userId;
        let selectedSource = await this.props.selectedSource;

        this.setState({contactsSearchActive: false, tableLoader: true, searchOpen: false})

        let columnName = this.state.sortData.name;
        let direction = this.state.sortData.direction;

        try {
            const contactsResult = await http.post('/api/user/' + userId + '/project/' + selectedSource + '/filter_contacts/page_size/' +
                this.state.pageSize + '?page=' + 1 + '&order=' + direction + '&sort=' + columnName, {
                "tag_ids": this.state.selectedTagsIds
            }, {headers: {authorization: getJwt()}})

            await this.setState({
                contacts: contactsResult.data.imported_contacts,
                totalPages: contactsResult.data.total_pages,
                totalContacts: contactsResult.data.total_count,
                selectedPage: 1,
                currentPage: 1,
                tableLoader: false,
                searchTerm: ''
            })
        } catch {
            toastr.error('Error with searching contacts')
        }
    }

    handleSortContacts = async (sortData) => {

        let userId = await this.props.userId;
        let selectedSource = await this.props.selectedSource;
        let columnName = sortData.name;
        let direction = sortData.direction === 'desc' ? 'dsc' : 'asc';
        this.setState({sortData, tableLoader: true})


        try {
            const contactsResult = await http.post('/api/user/' + userId + '/project/' + selectedSource + '/filter_contacts/page_size/' +
                this.state.pageSize + '?page=' + 1 + '&order=' + direction + '&sort=' + columnName, {
                "tag_ids": this.state.selectedTagsIds,
                "term": this.state.searchTerm
            }, {headers: {authorization: getJwt()}})

            await this.setState({
                contacts: contactsResult.data.imported_contacts,
                totalPages: contactsResult.data.total_pages,
                totalContacts: contactsResult.data.total_count,
                selectedPage: 1,
                currentPage: 1,
                tableLoader: false
            })
        } catch {
            toastr.error('Error with searching contacts')
        }
    }


    handleTagSearch = async (query) => {
        // console.log('tag search query: ', query);
        let bulkTags = await this.state.bulkTags
        let filtered = '';
        query = query.toLowerCase()
        if (query !== '') {
            // console.log('tag search query: ', query);
            filtered = await bulkTags.filter(tag => tag.name.toLowerCase().includes(query))
        } else {
            filtered = await bulkTags
        }
        // console.log('filtered tags: ', filtered);
        await this.setState({
            searchedBulkTags: filtered,
            createTagString: query
        });

    };

    handleSearch = async (query) => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Subscribers - Search',
        //     userId: getCurrentUserId(),
        //     label: query,
        //     nonInteraction: true
        // });
        // console.log('search handled:', query);
        //console.log('subscribers:', this.state.subscribers);
        let filtered = '';
        if (query !== '') {
            query = query.toLowerCase();
            //console.log('type of subscription:', this.state.type_of_subscription);
            //console.log('search: ', query);
            //&& sub.type_of_subscription === this.state.type_of_subscription
            let filteredSubs = this.state.searched_contacts;
            if (this.state.type_of_subscription !== 'all') {
                filteredSubs = filteredSubs.filter(sub => sub.type_of_subscription === this.state.type_of_subscription)
            }
            filtered = await filteredSubs.filter(sub => sub.subscriber_name.toLowerCase().includes(query));
        } else {
            //console.log('search: ', query);
            document.querySelector('#subs-search').blur();
            filtered = await this.state.searched_contacts

        }

        let lastPage = false;
        let indicator = filtered.length / this.state.pageSize;
        // console.log('indicator:', indicator);
        if (indicator % 1 !== 0 && indicator > 1) {
            indicator = Math.ceil(indicator)
        }
        let lastPageSize = await filtered.length % this.state.pageSize;
        if (lastPageSize === 0) {
            lastPageSize = this.state.pageSize
        }
        if (filtered.length === 0) {
            lastPage = true;
            lastPageSize = 0;
        }
        // console.log('indicator after: ', indicator);
        // console.log('last page size - search: ', lastPageSize);


        if (indicator === this.state.currentPage || indicator < 1) {
            lastPage = true
        }
        await this.setState({
            searched_contacts: filtered,
            searchQuery: query,
            currentPage: this.state.currentPage,
            last_page: lastPage,
            last_page_size: lastPageSize

        });
        this.updateTableWidth()


    };

    logSearch = query => {

        //console.log('search logged:', query);
        if (this.state.fullWidth === false) {
            this.setState({fullWidth: true})
        } else {
            //this.setState({fullWidth: false});
            document.querySelector('.subscribers-search').value = '';
        }

    };

    handleCheck = (checkedIndexes) => {
        // When contact is checked in this part contact is pushed to checkedContacts or removed from it, bulktags let is
        // created and subsCount and checkedSubsWithoutTag are set to 0 and []
        // for every contact checked, checkedContacts are being maped and bulktags are calculated for all the checkedContacts
        // It can be improved if changes are only updated instead of calculation being done on every contact checked.
        // Like this if you check 50 contacts one by one, it will take more time on every contact checked.
        // let checkedContacts = this.state.checkedContacts;
        // console.log('contacts in state: ', this.state.contacts)
        // console.log('handleCheck rowIndex ', rowIndex)
        // let checkedSub = this.state.contacts[rowIndex].id;
        // console.log('checked sub id: ', checkedSub)
        // if (checkedContacts.includes(checkedSub)) {
        //     this.removeElement(checkedContacts, checkedSub);
        // } else {
        //     checkedContacts = [...checkedContacts, checkedSub];
        // }
        // console.log('checked subscribers:', checkedContacts);

        // if(checkedIndexes.length < this.state.totalContacts){
        let checkedContacts = [];
        checkedIndexes.map(index => checkedContacts.push(this.state.contacts[index].id))

        this.setState({checkedContacts})
        let allTags = [...this.props.tags];
        let bulkTags = [];

        allTags.map(
            tag => {
                let newTag = {
                    id: tag.id,
                    name: tag.tag,
                    subsCount: 0,
                    checkedSubsWithoutTag: []
                };
                bulkTags = [...bulkTags, newTag]
            }
        );

        //let checkedSubs = await [...this.state.checkedSubscribers];
        // console.log('checked subs:', checkedContacts);
        // console.log('bulkTags let:', bulkTags);

        checkedContacts.map(checkedSub => {
                let fullCheckedSub = this.state.contacts.filter(sub => sub.id === checkedSub);
                // console.log('full checked sub', fullCheckedSub);
                let checkedSubTags = fullCheckedSub[0].tags
                // console.log('checked sub tags:', checkedSubTags)
                allTags.map(tag => {

                        // console.log('checked subscriber: ', checkedSub)
                        const matchedTags = checkedSubTags.filter(subTag => subTag.tag === tag.tag);

                        // console.log('matchedTags: ', matchedTags, allTags, checkedSubTags)
                        //if checked user has tags
                        if (matchedTags.length > 0) {
                            let specificTag = bulkTags.find(bulkTag => bulkTag.name === tag.tag);
                            let specTagCount = specificTag.subsCount;
                            // await console.log('specific tag:',specificTag, specTagCount );

                            specificTag = {
                                ...specificTag,
                                subsCount: specTagCount + 1
                            }
                            // console.log('specific tag after adding 1: ', specificTag)
                            let otherTags = bulkTags.filter(bulkTag => bulkTag.name !== tag.tag);
                            otherTags = [...otherTags, specificTag];
                            // console.log('otherTags: ', otherTags)
                            bulkTags = otherTags;
                            // console.log('bulk tags after all:', bulkTags);
                            this.setState({bulkTags, searchedBulkTags: bulkTags});
                            // console.log('bulkTags:', this.state.bulkTags);
                        }
                        // if checked user doesn't have tags
                        else {
                            // console.log('doesnt have tag: ', tag.tag)
                            let specificTag = bulkTags.find(bulkTag => bulkTag.name === tag.tag);
                            let otherTags = bulkTags.filter(bulkTag => bulkTag.name !== tag.tag);
                            specificTag.checkedSubsWithoutTag.push(checkedSub);
                            otherTags = [...otherTags, specificTag];
                            bulkTags = otherTags;
                            this.setState({bulkTags, searchedBulkTags: bulkTags});
                        }
                    }
                );

            }
        );
        // console.log('checkedContacts: ', checkedContacts, this.state.bulkTags, this.state.searchedBulkTags)
        this.setState({
            checkedContacts,
            allContactsChecked: checkedIndexes.length < this.state.pageSize ? false : true
        });
        // } else {
        //     this.setState({allContactsChecked: true})
        // }
    };


    removeElement(array, elem) {
        let index = array.indexOf(elem);
        if (index > -1) {
            array.splice(index, 1);
        }
    }

    handleTagRemove = async (item) => {
        this.setState({tableLoader: true})
        let selected_source = this.state.selected_source;
        let pageSize = this.state.pageSize;
        let currentPage = this.state.currentPage;

        const type = this.state.type_of_subscription || "all";
        let type_to_get = ''
        if (this.state.selectedType === 'fb') {

            type_to_get = "fb";
            if (type === "daily") {
                type_to_get = "fb_daily";
            } else if (type === "immediate") {
                type_to_get = "fb_immediate";
            } else if (type === "weekly") {
                type_to_get = "fb_weekly";
            } else if (type === "unsubscribed") {
                type_to_get = "fb_unsubscribed";
            }
        } else {
            type_to_get = 'wp'
        }

        let selectedTagsIds = [];
        //console.log('tag select item:', item);
        const selectedTags = this.state.selectedTags;


        // console.log('selected tags:', selectedTags);
        // console.log('item', item);
        // console.log('itemId:', item.key);

        const newTags = await selectedTags.filter(t => t.tag !== item.props.children);

        newTags.map(tag => {
            selectedTagsIds = [...selectedTagsIds, tag.id]
        });

        //console.log('newTags: ', newTags);
        // console.log('selectedTagsIds -  remove: ', selectedTagsIds);

        await this.setState({selectedTags: newTags});
        let userId = await this.props.userId;
        let selectedSource = await this.props.selectedSource;

        let columnName = this.state.sortData.name;
        let direction = this.state.sortData.direction;

        if (selectedTagsIds.length > 0) {
            try {
                const contactsResult = await http.post('/api/user/' + userId + '/project/' + selectedSource + '/filter_contacts/page_size/' +
                    this.state.pageSize + '?page=' + this.state.currentPage + '&order=' + direction + '&sort=' + columnName
                    , {
                        tag_ids: selectedTagsIds,
                        "term": this.state.searchTerm
                    },
                    {headers: {authorization: getJwt()}}
                );
                await this.setState({
                    selectedTagsIds,
                    contacts: contactsResult.data.imported_contacts,
                    totalContacts: contactsResult.data.total_count,
                    searched_contacts: contactsResult.data.imported_contacts,
                    tableLoader: false
                });
            } catch (ex) {
                this.setState({tableLoader: false})
                if (ex.response && ex.response.status === 404)
                    toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        } else {
            this.setState({
                currentPage: 1,
                checkedContacts: []
            });

            //document.querySelector('.table-checkmark:after').css('opacity','0')
            try {
                this.setState({loader: true});
                const selected_source = this.props.selected_source || JSON.parse(localStorage.source_clicked) || this.state.selected_source;
                const pageSize = this.state.pageSize;

                const type = this.state.type_of_subscription || "all";
                let type_to_get = ''
                if (this.state.selectedType === 'fb') {

                    type_to_get = "fb";
                    if (type === "daily") {
                        type_to_get = "fb_daily";
                    } else if (type === "immediate") {
                        type_to_get = "fb_immediate";
                    } else if (type === "weekly") {
                        type_to_get = "fb_weekly";
                    } else if (type === "unsubscribed") {
                        type_to_get = "fb_unsubscribed";
                    }
                } else {
                    type_to_get = 'wp'
                }

                const contactsResult = await http.get('/api/user/' + userId + '/project/' + selectedSource + '/imported_contacts/page_size/' + this.state.pageSize + '?page=' + this.state.currentPage, {headers: {authorization: getJwt()}})

                const data = contactsResult.data;
                let filtered = await data.imported_contacts;
                if (type !== 'unsubscribed' && type !== 'all') {
                    filtered = filtered.filter(f => f.unsubscribe !== 1)
                }
                let indicator = filtered.length / this.state.pageSize;
                //console.log('indicator:', indicator);
                if (indicator % 1 !== 0) {
                    indicator = Math.ceil(indicator)
                }
                let lastPageSize = filtered.length % this.state.pageSize;
                if (lastPageSize === 0) {
                    lastPageSize = this.state.pageSize
                }
                if (filtered.length === 0) {
                    indicator = 1;
                    lastPageSize = 0;
                }

                //  console.log('type of subscription:', type)
                await this.setState({
                    last_page_size: lastPageSize,
                    last_page: indicator === 1,
                    contacts: filtered,
                    searched_contacts: filtered,
                    totalContacts: data.total_count,
                    tableLoader: false,
                    //subscription_filter: type_of_subscription.target.id
                });
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        }
        // this.updateTableWidth()

    };

    multiMenuItem = (item, {modifiers, handleClick}) => {
        if (this.state.selectedTags.includes(item) === false) {
            return (

                <MenuItem
                    className='multiselect-menu-item'
                    active={modifiers.active}
                    key={item.id}
                    label=''
                    text={item.tag}
                    onClick={handleClick}
                    query=''
                    shouldDismissPopover={true}

                />
            )
        } else {
            return (
                <MenuItem
                    className='multiselect-menu-item'
                    icon='small-tick'
                    active={modifiers.active}
                    key={item.id}
                    label=''
                    text={item.tag}
                    onClick={handleClick}
                    shouldDismissPopover={true}
                />
            )
        }
    }

    tagSelect = async (item) => {
        this.setState({tableLoader: true})
        // console.log('tag selected: ', item);
        let selected_source = this.state.selected_source;
        let pageSize = this.state.pageSize;
        let currentPage = this.state.currentPage;

        // this.setState({tableLoader: true})
        let userId = await this.props.userId;
        let selectedSource = await this.props.selectedSource;

        let selectedTagsIds = [];
        //console.log('tag select item:', item);
        const selectedTags = this.state.selectedTags;


        //console.log('selected tags ids:', selectedTagsIds);
        if (selectedTags.includes(item) === false) {

            selectedTags.push(item);
            await this.setState({selectedTags: selectedTags});
        } else {
            const newTags = await selectedTags.filter(t => t !== item);
            await this.setState({selectedTags: newTags})
        }

        await this.state.selectedTags.map(tag => {
            selectedTagsIds = [...selectedTagsIds, tag.id]
        });


        // console.log('selected tags ids - select:', selectedTagsIds);

        // console.log('tags select end')

        // if (selectedTagsIds.length !== 0) {

        let columnName = this.state.sortData.name;
        let direction = this.state.sortData.direction;

        try {
            const contactsResult = await http.post('/api/user/' + userId + '/project/' + selectedSource + '/filter_contacts/page_size/' +
                this.state.pageSize + '?page=' + 1 + '&order=' + direction + '&sort=' + columnName
                , {
                    tag_ids: selectedTagsIds,
                    "term": this.state.searchTerm
                },
                {headers: {authorization: getJwt()}}
            );
            // let lastPage = false;

            await this.setState({
                selectedTagsIds,
                contacts: contactsResult.data.imported_contacts,
                totalContacts: contactsResult.data.total_count,
                tableLoader: false
                // searched_contacts: contactsResult.data.imported_contacts,
                // last_page_size: lastPageSize,
                // lastPage: lastPage
            })
        } catch (ex) {
            this.setState({tableLoader: false})
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
    };
    filterTags = (item) => {

        //console.log('filter item:', item);

        return this.props.tags.filter((t) => {
            return t.tag.toLowerCase().includes(item.toLowerCase());
        });
    };
    tagRender = (item) => {


        // console.log('tag render item:', item);
        // console.log('')
        return (
            <Tag key={item.id}>{item.tag}</Tag>
        )
        // console.log('tag render end');
    };

    handleCreateAddTag = async (e) => {
        let createTagString = e || this.state.createTagString;

        // console.log('handleCreateAddTag: ', createTagString)
        if (createTagString === '') {
            toastr.error("Please add a tag name to create a tag!");
            document.querySelector('#find-tag').focus()
        } else {
            let tagExists = this.state.bulkTags.filter(bulkTag => bulkTag.name === createTagString);
            // console.log('tagExists let: ',);

            if (tagExists.length > 0) {
                toastr.error("This tag already exists! Please choose a different tag name.");

            } else {
                await this.setState({createTagLoader: true})
                await this.props.handleCreateTag(createTagString);
                await this.props.handleGetTags();
                //console.log('props tags:', this.props.tags);
                this.handleBulkAction('', this.props.tags[0].id);
                toastr.success("You have successfully created and assigned tag!");
                await this.setState({createTagLoader: false})
            }
        }

    };

    handleBulkAction = async (e, id) => {
        // console.log('bulk actions value:', e.target);
        // console.log('tag id: ', id);
        let columnName = this.state.sortData.name;
        let direction = this.state.sortData.direction;

        this.setState({createTagString: ''});

        let selected_source = this.props.selectedSource;
        let data = [];
        let pageSize = this.state.pageSize;
        let currentPage = this.state.currentPage;
        if (document.querySelector('#find-tag')) {
            document.querySelector('#find-tag').setAttribute('value', '');
        }
        let typeOfCheckbox = '';
        if (e === '') {
            typeOfCheckbox = 'clear'
        } else if (e.target.classList.contains('clear')) {
            typeOfCheckbox = 'clear'

        } else if (e.target.classList.contains('half')) {
            typeOfCheckbox = 'half'
        } else {
            typeOfCheckbox = 'full'
        }
        // console.log(
        //     'type of chekcbox:', typeOfCheckbox
        // )
        // const type = this.state.type_of_subscription || "all";
        // let type_to_get = ''
        // if (this.state.selectedType === 'fb') {
        //
        //     type_to_get = "fb";
        //     if (type === "daily") {
        //         type_to_get = "fb_daily";
        //     } else if (type === "immediate") {
        //         type_to_get = "fb_immediate";
        //     } else if (type === "weekly") {
        //         type_to_get = "fb_weekly";
        //     } else if (type === "unsubscribed") {
        //         type_to_get = "fb_unsubscribed";
        //     }
        // } else {
        //     type_to_get = 'wp'
        // }
        //Adding tag to all selected subscribers

        if (typeOfCheckbox === 'clear') {
            // console.log('add tag')

            try {
                await this.setState({bulkLoader: true});
                if (this.state.allContactsChecked) {
                    this.setState({
                        tagsImportActive: true,
                        bulkIsOpen: false
                    })
                }

                // console.log('id :', id);
                // console.log('subscriber ids:', this.state.checkedSubscribers);
                // console.log('clear call:', 'api/source/' + selected_source + '/subscriber_tags/type/' + type_to_get + '/page_size/' + pageSize + '?page=' + currentPage);

                let result = await http.post('api/project/' + selected_source + '/contacts_tags/type/import_contacts/page_size/' +
                    this.state.pageSize + '?page=' + currentPage + '&order=' + direction + '&sort=' + columnName
                    , {
                        tag_ids: [id],
                        subscriber_ids: this.state.checkedContacts
                    }, {headers: {authorization: getJwt()}});
                // console.log('clear response: ', result);
                data = await result.data.contacts.data;
                await this.setState({
                    contacts: result.data.contacts.data,
                    totalContacts: result.data.total_contacts,
                    searched_contacts: result.data.contacts.data,
                    bulkLoader: false,
                    tagsImportActive: false,
                    bulkIsOpen: undefined,
                    checkedContacts: [],
                    rowsSelected: [],
                    searchTerm: '',
                    selectedTags: []
                });
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }


            //Adding tag to selected subscribers which doesn't have that tag
        } else if (typeOfCheckbox === 'half') {
            await this.setState({bulkLoader: true});
            if (this.state.allContactsChecked) {
                this.setState({
                    tagsImportActive: true,
                    bulkIsOpen: false
                })
            }

            //console.log('add tags to ones which doesnt have it ')
            // console.log('bulk tag id', id);
            let bulkTag = this.state.bulkTags.find(tag => tag.id === id);
            // console.log('bulkTag  subs:', bulkTag);
            try {
                // console.log('id :', id);
                // console.log('subscriber ids:', this.state.checkedSubscribers);


                let result = await http.post('api/project/' + selected_source + '/contacts_tags/type/import_contacts/page_size/' +
                    this.state.pageSize + '?page=' + currentPage + '&order=' + direction + '&sort=' + columnName
                    , {
                        tag_ids: [id],
                        subscriber_ids: bulkTag.checkedSubsWithoutTag,
                        "term": this.state.searchTerm
                    }, {headers: {authorization: getJwt()}});

                data = result.data.contacts.data;

                // console.log('partial response: ', data);
                await this.setState({
                    contacts: result.data.contacts.data,
                    totalContacts: result.data.total_contacts,
                    searched_contacts: result.data.contacts.data,
                    bulkLoader: false,
                    tagsImportActive: false,
                    bulkIsOpen: undefined,
                    checkedContacts: [],
                    rowsSelected: [],
                    searchTerm: '',
                    selectedTags: []
                });

            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }

            //Removing tag from all selected subscribers
        } else {
            //console.log('remove tag')
            try {
                await this.setState({bulkLoader: true});
                if (this.state.allContactsChecked) {
                    this.setState({
                        tagsImportActive: true,
                        bulkIsOpen: false
                    })
                }

                // console.log('id :', id);
                // console.log('subscriber ids:', this.state.checkedSubscribers);
                let result = await http.post('api/project/' + selected_source + '/contacts_tags_remove/type/import_contacts/page_size/' +
                    this.state.pageSize + '?page=' + currentPage + '&order=' + direction + '&sort=' + columnName
                    , {
                        tag_ids: [id],
                        subscriber_ids: this.state.checkedContacts
                    }, {headers: {authorization: getJwt()}});

                data = result.data.contacts.data;
                // console.log('remove response: ', data);
                await this.setState({
                    contacts: result.data.contacts.data,
                    totalContacts: result.data.total_contacts,
                    searched_contacts: result.data.contacts.data,
                    bulkLoader: false,
                    tagsImportActive: false,
                    bulkIsOpen: undefined,
                    checkedContacts: [],
                    rowsSelected: [],
                    searchTerm: '',
                    selectedTags: []
                });

            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        }
        this.setState({
            contacts: data,
            searched_contacts: data
        });
        let userId = await this.props.userId;
        let selectedSource = await this.props.selectedSource;

        this.reloadBulkActions();
    };
    reloadBulkActions = () => {
        let checkedSubscribers = this.state.checkedContacts;
        // console.log('checkedSubscribers:', checkedSubscribers);
        let allTags = [...this.props.tags];
        let bulkTags = [];
        allTags.map(
            tag => {
                let newTag = {
                    id: tag.id,
                    name: tag.tag,
                    subsCount: 0,
                    checkedSubsWithoutTag: []
                };
                bulkTags = [...bulkTags, newTag]
            }
        );
        checkedSubscribers.map(checkedSub => {
                // console.log('checked sub:', checkedSub, this.state.checkedContacts);
                let fullCheckedSub = this.state.contacts.filter(sub => sub.id === checkedSub);
                // console.log('full checked sub', fullCheckedSub)
                let checkedSubTags = fullCheckedSub.length > 0 ? fullCheckedSub[0].tags : []
                // console.log('checked sub tags:', checkedSubTags)
                allTags.map(async tag => {


                        // console.log('checked subscriber: ', checkedSub)
                        const matchedTags = checkedSubTags.filter(subTag => subTag.tag === tag.tag);

                        // console.log('matched tags:', matchedTags)


                        //if checked user has tags
                        if (matchedTags.length > 0) {
                            let specificTag = bulkTags.find(bulkTag => bulkTag.name === tag.tag);
                            //console.log('specific tag:',specificTag);
                            specificTag.subsCount = specificTag.subsCount + 1;
                            let otherTags = bulkTags.filter(bulkTag => bulkTag.name !== tag.tag);
                            otherTags = [...otherTags, specificTag];
                            bulkTags = otherTags;
                            // console.log('bulk tags after all:', bulkTags);
                        }
                        //if checked user doesn't have tags
                        else {
                            //console.log('doesnt have tag: ', tag.tag)
                            let specificTag = bulkTags.find(bulkTag => bulkTag.name === tag.tag);
                            let otherTags = bulkTags.filter(bulkTag => bulkTag.name !== tag.tag);
                            specificTag.checkedSubsWithoutTag.push(checkedSub);
                            otherTags = [...otherTags, specificTag];
                            bulkTags = otherTags;

                        }
                    }
                );

            }
        );
        //console.log('bulkTags:', bulkTags);
        this.setState({bulkTags, searchedBulkTags: bulkTags});
    };

    handleSelectAll = async (e) => {
        //console.log('handle select all');
        //console.log('clicked element:', e.currentTarget);
        if (e.currentTarget.classList.contains('clear')) {
            let onlyIds = await [];
            let allSubs = await this.state.contacts;
            //console.log('all subs:', allSubs);
            allSubs.map(async sub => {

                    await onlyIds.push(sub.id);
                }
            );
            //console.log('onlyIds', onlyIds);
            await this.setState({checkedContacts: onlyIds, selectAllChecked: true})
        } else {
            await this.setState({checkedContacts: [], selectAllChecked: false})
        }
        await this.reloadBulkActions();
        // this.updateTableWidth()

    };

    isValidEmailAddress = (e) => {
        let mail = e || '';
        return !!mail.match(/.+@.+/);
    }

    getFullPhoneNumber = (phoneObject) => {
        let phone = phoneObject.phone.toString();
        let dialCode = phoneObject.dialCode;

        if (phone.startsWith('00')) {
            phone = phone.substring(2);
            phone = '+' + phone;
            // console.log('Vratio je prvi if: ', phone)
            return phone
        } else if (phone.startsWith('0')) {
            phone = phone.substring(1);
            phone = '+' + dialCode + phone;
            // console.log('Vratio je drugi if: ', phone)
            return phone
        } else if (phone.startsWith('+')) {
            // console.log('Vratio je treci if: ', phone)
            return phone
        } else if (phone && (phone !== '+')) {
            phone = '+' + dialCode + phone;
            // console.log('Vratio je cetvrti if: ', phone)
            return phone
        } else {
            // console.log('Vratio je peti if: ', phone)
            return ''
        }
    }

    saveContact = async (contact) => {
        //console.log('Evo contact objekta za poziv: ', contact.tags, contact)
        this.setState({saveContactLoader: true})
        let userId = await this.props.userId;
        let selectedSource = await this.props.selectedSource;

        if (userId && selectedSource && contact) {
            if (!contact.phone.phone || (contact.phone.phone.length < 6) || (contact.phone.phone.length > 20)) {
                this.setState({
                    addContactError: 'For adding contact you need to enter valid phone number',
                    saveContactLoader: false
                })
                // } else if (this.isValidEmailAddress(contact.email) === false) {
                //     this.setState({addContactError: 'Your email is invalid', saveContactLoader: false})
            } else {
                try {
                    const contactsResult = await http.post('/api/user/' + userId + '/project/' + selectedSource + '/add_contacts/page_size/' + this.state.pageSize + '?page=' + this.state.currentPage
                        , {
                            "import_contacts": [{
                                "phone": this.getFullPhoneNumber(contact.phone),
                                "name": contact.name || "",
                                "email": contact.email || "",
                                "company": contact.company || "",
                                "subscription_type": contact.subscription_type.toLowerCase() || "",
                                "additional_fields": "",
                                // "country_code": contact.phone.dialCode
                            }],
                            "tag_ids": contact.tags || []
                        }, {headers: {authorization: getJwt()}})
                    // console.log('Ovo je rez dodavanja novog kontakta: ', contactsResult)
                    if (contactsResult.data.duplicate_contacts) {
                        await this.setState({
                            saveContactLoader: false,
                            addContactError: 'Contact with this phone number already exists'
                        })
                        // toastr.error('Contact with this phone number already exists')
                    } else if (contactsResult.data.improper_phones) {
                        await this.setState({
                            saveContactLoader: false,
                            addContactError: "Phone number you entered (" + contactsResult.data.improper_phones[0] + ") wasn't in correct format"
                        })
                    } else {
                        await this.setState({
                            contacts: contactsResult.data.contacts.data,
                            searched_contacts: contactsResult.data.contacts.data,
                            totalContacts: contactsResult.data.total_contacts,
                            totalPages: contactsResult.data.total_pages,
                            addContactModalActive: false,
                            saveContactLoader: false,
                            addContactError: ''
                        })
                        toastr.success('Contact is successfully saved')
                    }
                } catch (e) {
                    this.setState({
                        addContactError: 'Adding contact was unsuccessfull, please try again!',
                        saveContactLoader: false
                    })
                }
            }
        }
    }

    editContact = async (contact) => {
        this.setState({editContactLoader: true})
        let userId = await this.props.userId;
        let selectedSource = await this.props.selectedSource;

        if (userId && selectedSource && contact) {
            if (!contact.phone.phone || (contact.phone.phone.length < 6) || (contact.phone.phone.length > 20)) {
                this.setState({
                    editContactError: 'For adding contact you need to enter valid phone number',
                    editContactLoader: false
                })
                // } else if (this.isValidEmailAddress(contact.email) === false) {
                //     this.setState({addContactError: 'Your email is invalid', saveContactLoader: false})
            } else {
                try {
                    const contactsResult = await http.patch('/api/user/' + userId + '/project/' + selectedSource + '/single_contact/' + contact.contactId + '/page_size/' + 100
                        , {
                            "phone": this.getFullPhoneNumber(contact.phone),
                            "name": contact.name || "",
                            "email": contact.email || "",
                            "company": contact.company || "",
                            "subscription_type": contact.subscription_type.toLowerCase() || "",
                            "additional_fields": "",
                            "tag_ids": contact.tags
                            // "country_code": contact.phone.dialCode
                        },
                        {
                            headers: {authorization: getJwt()}
                        })
                    // console.log('Ovo je rez dodavanja novog kontakta: ', contactsResult)
                    if (contactsResult.data.duplicate_contacts) {
                        await this.setState({
                            editContactLoader: false,
                            editContactError: 'Contact with this phone number already exists'
                        })
                        // toastr.error('Contact with this phone number already exists')
                    } else if (contactsResult.data.improper_phones) {
                        await this.setState({
                            editContactLoader: false,
                            editContactError: "Phone number you entered (" + contactsResult.data.improper_phones[0] + ") wasn't in correct format"
                        })
                    } else {
                        await this.setState({
                            contacts: contactsResult.data.imported_contacts,
                            searched_contacts: contactsResult.data.imported_contacts,
                            totalContacts: contactsResult.data.total_count,
                            totalPages: contactsResult.data.total_pages,
                            editContactModalActive: false,
                            editContactLoader: false,
                            editContactError: ''
                        })
                        toastr.success('Contact is successfully saved')
                    }
                } catch (e) {
                    this.setState({
                        editContactError: 'Adding contact was unsuccessfull, please try again!',
                        editContactLoader: false
                    })
                }
            }
        }
    }

    deleteContacts = async (data, totalContacts, currentPage, totalPages) => {
        let userId = await this.props.userId;
        let selectedSource = await this.props.selectedSource;

        if (data === 'Cancel') {
            await this.setState({deleteContactsModalActive: false})
        } else {
            await this.setState({
                contacts: data,
                searched_contacts: data,
                deleteContactsModalActive: false,
                checkedContacts: [],
                totalContacts,
                totalPages,
                currentPage,
                selectAllChecked: false,
                rowsSelected: []
            })
        }
        // console.log('Response in contacts after delete: ', data)
    }

    deleteAllContacts = async () => {
        this.setState({deleteAllContactsLoader: true})
        let userId = await this.props.userId;
        let selectedSource = await this.props.selectedSource;

        if (userId && selectedSource) {

            try {
                const contactsResult = await http.delete('/api/user/' + userId + '/project/' + selectedSource + '/delete_contacts', {headers: {authorization: getJwt()}});
                toastr.success('Contacts successfully deleted')
                this.setState({
                    deleteAllContactsLoader: false,
                    deleteAllContactsModalActive: false,
                    contacts: [],
                    searched_contacts: [],
                    checkedContacts: [],
                    totalContacts: 0,
                    totalPages: 1,
                    currentPage: 1
                })
            } catch (e) {
                this.setState({
                    deleteAllContactsLoader: false,
                    deleteAllContactsModalActive: false
                })
            }
        }
    }

    handleEditContact = (id) => {
        let contact = this.state.contacts.find(contact => contact.id === id);
        // console.log('contact: ', id, contact)
        this.setState({selectedContact: contact, editContactModalActive: true})
    }

    noContactsRenderer = () => {
        return <div className='no-contacts-container panel-container'>
            <img src="/img/emptyStates/no-contacts-image.gif"/>
            {(!this.state.contacts || !this.state.contacts.length) && (this.state.selectedTags && this.state.selectedTags.length) ?
                <h2>No contacts with selected tags.</h2>
                :
                <h2>No added contacts yet.</h2>
            }
            {(!this.state.contacts || !this.state.contacts.length) && (this.state.selectedTags && this.state.selectedTags.length) ?
                <p>There are no contacts with selected tags, you can select other tag or add tags to existing
                    contact.</p>
                :
                <p>There are no contacts imported, you can add a single contact or import multiple contacts.</p>
            }
            {(!this.state.contacts || !this.state.contacts.length) && (this.state.selectedTags && this.state.selectedTags.length) ?
                ''
                :
                <div className='flex-column justify-content-center'>
                    <button
                        onClick={() => this.props.history.push('/import-contacts')}
                        className=' btn-action margin-bottom-10'>
                        Import Contacts
                    </button>

                </div>
            }
        </div>
    };

    tableLoaderRenderer = () => {
        return <div className='table-loader-container'>
            <ChartLoader/>
        </div>
    }

    tableLoaderAbsoluteRenderer = () => {
        return <Overlay
            // onClose={this.props.handleClose}
            className={Classes.OVERLAY_SCROLL_CONTAINER}
            // isOpen={this.state.overlayIsOpen}
            isOpen={true}
            backdropClassName={'table-loader-absolute-modal-background-color'}
        >
            <div className='table-loader-container-absolute'>
                <ChartLoader/>
            </div>
        </Overlay>

    }

    getMuiTheme = () => createTheme(Theme)

    render() {

        const {searchQuery, sub_type} = this.state;
        let selectedSource = this.props.selectedSource;
        const columns = [
            {
                name: "name",
                label: "Name",
                options: {
                    filter: false,
                    sort: true,
                }
            },
            {
                name: "email",
                label: "Email",
                options: {
                    filter: false,
                    sort: true,
                }
            },
            {
                name: "phone",
                label: "Phone Number",
                options: {
                    filter: false,
                    sort: false,
                }
            },
            {
                name: "country",
                label: "Country",
                options: {
                    filter: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        // console.log('tableMeta: ', tableMeta)
                        let contactCountry = countries.find(country => {
                            if (value) {
                                return country.code === value
                            } else {
                                return ('')
                            }
                        })
                        return (


                            contactCountry ?
                                contactCountry.flag ?
                                    <div className='text-center f-16'>
                                        {contactCountry.flag}
                                    </div>
                                    : ''
                                : ''
                        )
                    }
                }
            },
            {
                name: "tags",
                label: "Tags",
                options: {
                    filter: true,
                    filterOptions: {
                        names: this.state.tagsNames,
                        logic: (tags, checkedTags, row) => {
                            if (checkedTags.length && row[3].length && row[3].some(tag => checkedTags.includes(tag.tag))) {
                                return false;
                            } else {
                                return true;
                            }
                        },
                    },
                    filterType: 'checkbox',
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        // console.log('tableMeta: ', tableMeta)
                        return value.length ? value.map(tag => <Tag
                            className={['custom-tag', tag.tag.toLowerCase() === 'immediate' ? 'bp3-intent-primary' : tag.tag.toLowerCase() === 'daily' ?
                                'bp3-intent-success' : tag.tag.toLowerCase() === 'weekly' ? 'bp3-intent-warning' :
                                    tag.tag.toLowerCase() === 'weekly' ? 'bp3-intent-darkblue' : '']}
                            key={tag.tag}
                        >
                            {tag.tag.toLowerCase()}
                        </Tag>) : ''
                    }
                }
            },
            {
                name: "updated_at_timezone",
                label: "Last Changes",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.contacts[tableMeta.rowIndex];

                        let dateConverted = item.updated_at ? this.props.isodateToDate(item.updated_at) : ''

                        return <div>{dateConverted}</div>
                    }
                }
            },
            {
                name: "unsubscribe",
                label: "Subscription",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.contacts[tableMeta.rowIndex];

                        return <div className='display-flex flex-col-center max-width-80-60'>{
                            item.unsubscribe ?
                                <img src="/img/material-close.png" alt="unavailable"/>
                                :
                                <img src="/img/double-tick-indicator.png" alt="available"/>
                        }</div>
                    }
                }
            },
            {
                name: "id",
                label: "Actions",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        return <Icon icon='annotation' onClick={() => this.handleEditContact(value)}
                                     className='shortener-action'/>
                    }
                }
            },
        ];

        const options = {
            // customSearch: (searchQuery, currentRow, columns) => console.log('customSearch: ', searchQuery, currentRow, columns),
            onSearchChange: (text) => this.handleSearchContacts(text),
            onSearchClose: this.handleSearchContactsClose,
            onSearchOpen: () => this.setState({searchOpen: true}),
            searchText: this.state.searchTerm,
            // customSort: (data, colIndex, order, meta) => {
            //     console.log('customSort: ', data, colIndex, order, meta)
            // },
            // onFilterChange: (changedColumn, filterList, type, changedColumnIndex, displayData) => {console.log('onFilterChange:', changedColumn, filterList, type, changedColumnIndex, displayData)},
            // customSearchRender: (searchText, handleSearch, hideSearch, options) => console.log('customSearchRender: ', searchText, handleSearch, hideSearch, options),
            serverSide: true,
            count: this.state.totalContacts,
            filterType: 'checkbox',
            rowsPerPage: this.state.pageSize,
            print: false,
            search: true,
            filter: false,
            sort: true,
            onChangeRowsPerPage: (number) => this.handleRowsPerPageChange(number),
            page: this.state.currentPage - 1,
            rowsPerPageOptions: [25, 50, 100],
            rowsSelected: this.state.rowsSelected,
            textLabels: {
                body: {
                    noMatch: this.state.initialTableLoader ?
                        this.tableLoaderRenderer()
                        :
                        'Sorry, there is no matching data to display',
                },
            },
            onTableChange: (action, tableState) => {
                // console.log(action, tableState);

                // a developer could react to change on an action basis or
                // examine the state as a whole and do whatever they want

                switch (action) {
                    case 'changePage':
                        this.handlePageChange(tableState.page + 1);
                        break;
                    case 'sort':
                        this.handleSortContacts(tableState.sortOrder)
                        break;
                    // default:
                    //     console.log('action not handled.');
                }
            },
            downloadOptions: {
                filename: 'emittoContactsDownload.csv',
                separator: ',',
                filterOptions: {
                    useDisplayedColumnsOnly: true
                }
            },
            customToolbar: ({displayData}) => {
                return <div className='total-contacts-number'>
                    {
                        !this.state.searchOpen ?
                            <p className='MuiTypography-subtitle1'>
                                {this.state.totalContacts} {this.state.totalContacts && (this.state.totalContacts > 1) ? 'contacts' : 'contact'} total
                            </p>
                            :
                            ''
                    }
                </div>
            },
            customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
                <CustomToolbarSelect
                    selectedRows={selectedRows}
                    displayData={displayData}
                    setSelectedRows={setSelectedRows}
                    createTagString={this.state.createTagString}
                    checkedContacts={this.state.checkedContacts}
                    bulkTags={this.state.bulkTags}
                    searchedBulkTags={this.state.searchedBulkTags || []}
                    bulkLoader={this.state.bulkLoader}
                    handleDeleteContacts={() => this.setState({deleteContactsModalActive: true})}
                    handleDeleteAllContacts={() => this.setState({deleteAllContactsModalActive: true})}
                    allContactsChecked={this.state.allContactsChecked}
                    handleCreateAddTag={this.handleCreateAddTag}
                    handleBulkAction={this.handleBulkAction}
                    handleTagSearch={this.handleTagSearch}
                    createTagLoader={this.state.createTagLoader}
                    bulkIsOpen={this.state.bulkIsOpen}
                />
            ),
            customFooter: (
                count,
                page,
                rowsPerPage,
                changeRowsPerPage,
                changePage,
                textLabels
            ) => {
                return <CustomFooter
                    count={count}
                    totalPages={this.state.totalPages}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    changePage={changePage}
                    changeRowsPerPage={changeRowsPerPage}
                    textLabels={textLabels}
                />;
            },
            onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
                this.setState({rowsSelected});
                this.handleCheck(rowsSelected)
                //console.log('currentRowsSelected: ', currentRowsSelected, ' allRowsSelected:', allRowsSelected, ' rowsSelected:', rowsSelected)
            }

        };


        if (!selectedSource) {
            return <React.Fragment>
                <div className="display-flex">
                    <h1 className='main-title'>Contacts</h1>
                </div>

                <div className="row">
                    <div className="col-xs-12 text-center no-feeds-containers">
                        <div className="feed-msg">
                            <img className='emitto-mark' src="/img/emitto-mark.png" alt="Emitto Mark"/>
                            <p className="text-center ">{authService.getCurrentUserName()}</p>
                            <p>It looks like you haven't set up any workspaces yet. Add your first workspace, and start
                                growing
                                your audience.</p>
                            <img className='cat-img' src="/img/cat-transparent.gif" alt="No Workspaces"/>
                        </div>
                        <button className='btn-m btn-action' onClick={this.props.addSource} type="button">
                            Create your first workspace
                        </button>
                    </div>
                </div>
            </React.Fragment>
        }
        let {
            subscribers: subscribersAll,
            //push_subscribers: subscribersPush
        } = this.state;


        let filtered = subscribersAll;
        if (searchQuery) {
            if (sub_type) {
                filtered = subscribersAll.filter(m => m.subscriber_name.toLowerCase().includes(searchQuery.toLowerCase()));
            }
        }
        // const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
        // const campaigns = paginate(sorted, currentPage, pageSize);
        return (
            <React.Fragment>
                {
                    this.state.tableLoader ?
                        this.tableLoaderAbsoluteRenderer()
                        :
                        ''
                }
                <h1 className='main-title'>Contacts</h1>
                <div className="d-block">
                    <div className="contacts-filtering-container">
                        <div className="left-part">
                            <MultiSelect
                                items={this.props.tags}
                                itemRenderer={this.multiMenuItem}
                                tagInputProps={{
                                    placeholder: 'Filter by tag',
                                    onRemove: this.handleTagRemove
                                }}
                                resetOnSelect={true}
                                className='tag-multiselect margin-bottom-10'
                                onItemSelect={this.tagSelect}
                                tagRenderer={this.tagRender}
                                itemListPredicate={this.filterTags}
                                selectedItems={this.state.selectedTags}
                                fill={true}
                                noResults={<MenuItem disabled={true} text="No results."/>}
                            />
                            {/*<div className="tabs-navigation">*/}
                            {/*    <div className="navigation-tab active">*/}
                            {/*        Show All - {this.state.totalContacts} {this.state.loadingContactsFull ?*/}
                            {/*        <i className='fa fa-spin fa-spinner' style={{marginLeft: 5}}/> : ''}*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                        <div className="right-part">
                            <button onClick={() => this.setState({addContactModalActive: true})}
                                    className='btn-white-border bold margin-bottom-10'
                                    data-intercom-target="add-contact-button">
                                Add Contact
                            </button>
                            <button onClick={() => this.props.history.push('/import-contacts')}
                                    className=' btn-action margin-bottom-10'>
                                Import Contacts
                            </button>

                            <div className="input-button subscribers-search margin-bottom-10">
                                <SearchBox
                                    value={searchQuery}
                                    onChange={this.handleSearch}
                                    logSearch={this.logSearch}
                                    fullWidth={this.state.fullWidth}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.contactsImportActive ?
                    <div className="contacts-import-status">
                        <h2>Contacts are being imported.</h2>
                        <p>You can navigate away from this page - importing won't be affected.</p>
                    </div>
                    :
                    ''
                }
                {this.state.contactsAdded ?
                    <Callout intent={Intent.SUCCESS}>
                        {this.state.contactsAdded} contacts successfully imported.
                    </Callout>
                    :
                    ''
                }
                {this.state.contactsNotImported ?
                    <Callout intent={Intent.DANGER}>
                        {this.state.contactsNotImported} contacts not imported. You can download CSV file with not
                        imported contacts
                        <CSVLink
                            data={this.state.arrayOfUnsuccessfulImportedContacts}
                            filename={"contacts-not-imported.csv"}
                            target="_blank"
                        > here</CSVLink>.
                    </Callout>
                    :
                    ''
                }
                {this.state.tagsImportActive ?
                    <div className="contacts-import-status">
                        <h2>Tags are being assigned.</h2>
                        <p>You can navigate away from this page - assigning won't be affected.</p>
                    </div>
                    :
                    ''
                }

                {/* Main part of the screen */}
                {
                    this.state.initialTableLoader ?
                        this.tableLoaderRenderer()
                        :
                        (!this.state.contacts || !this.state.contacts.length) && !this.state.initialTableLoader && !this.state.contactsSearchActive ?
                            this.noContactsRenderer()
                            :
                            <MuiThemeProvider theme={this.getMuiTheme()}>
                                <MUIDataTable
                                    title={""}
                                    data={this.state.contacts}
                                    columns={columns}
                                    options={options}
                                />
                            </MuiThemeProvider>
                }
                <AddContactModal
                    showModal={this.state.addContactModalActive}
                    saveContact={this.saveContact}
                    handleClose={() => this.setState({addContactModalActive: false, addContactError: ''})}
                    maxWidth={500}
                    history={this.props.history}
                    tags={this.props.tags}
                    addContactError={this.state.addContactError}
                    saveContactLoader={this.state.saveContactLoader}
                    handleCreateTag={this.handleCreateAddTag}
                    handleGetTags={this.props.handleGetTags}
                />
                <AddContactModal
                    showModal={this.state.editContactModalActive}
                    editContactCheck={true}
                    editContactData={this.state.selectedContact}
                    editContact={this.editContact}
                    handleClose={() => this.setState({editContactModalActive: false, editContactError: ''})}
                    maxWidth={500}
                    history={this.props.history}
                    tags={this.props.tags}
                    addContactError={this.state.editContactError}
                    editContactLoader={this.state.editContactLoader}
                    handleCreateTag={this.handleCreateAddTag}
                    handleGetTags={this.props.handleGetTags}
                />
                <DeleteContactsModal
                    showModal={this.state.deleteContactsModalActive}
                    user={this.props.userId}
                    selected_source={this.props.selectedSource}
                    checkedContactsIds={this.state.checkedContacts}
                    pageSize={this.state.pageSize}
                    currentPage={this.state.currentPage}
                    totalContacts={this.state.totalContacts}
                    totalPages={this.state.totalPages}
                    deleteContacts={this.deleteContacts}
                    handleClose={() => this.setState({deleteContactsModalActive: false})}
                    maxWidth={500}
                    history={this.props.history}
                    tags={this.props.tags}
                />
                <DeleteContactsModal
                    type={'deleteAllContacts'}
                    showModal={this.state.deleteAllContactsModalActive}
                    user={this.props.userId}
                    selected_source={this.props.selectedSource}
                    checkedContactsIds={this.state.checkedContacts}
                    pageSize={this.state.pageSize}
                    currentPage={this.state.currentPage}
                    totalContacts={this.state.totalContacts}
                    totalPages={this.state.totalPages}
                    deleteContacts={this.deleteAllContacts}
                    handleClose={() => this.setState({deleteAllContactsModalActive: false})}
                    maxWidth={500}
                    history={this.props.history}
                    tags={this.props.tags}
                />
            </React.Fragment>
        )
    }
}

export default sizeMe()(Contacts);